export default __webpack_public_path__ + "static/media/C6.69731a99.svg";